import { PageMeta } from "../types";

export type TransactionType = "buy" | "sell" | "send" | "receive";

export const TRANSACTION_TYPES: TransactionType[] = ["buy", "sell"];

export interface TokenInfo {
  address: string;
  name: string;
  symbol: string;
  iconUrl: string;
  usdValue: string;
  amount: string;
}

export interface Transaction {
  hash: string;
  tokenInfo: TokenInfo;
  type: "swap" | TransactionType;
  inflow?: TokenInfo;
  outflow?: TokenInfo;
  usdValue: string;
  from?: string;
  to?: string;
  time: string;
}

export interface TransactionsResponse {
  transactions: Transaction[];
  meta: PageMeta;
}

export interface TransactionBot {
  chainId: number;
  isBuy: boolean;
  isConfirmed: boolean;
  isSuccess: boolean;
  nativeAmount: string;
  nativePrice: number;
  pair: string;
  timestamp: number;
  token: string;
  tokenAmount: string;
  tokenDecimals: number;
  tokenImage: string;
  tokenName: string;
  tokenPrice: number;
  tokenSymbol: string;
  txHash: string;
  usdValue: number;
  userId: string;
  walletAddress: string;
  amountFormatted: number;
}

export interface TransactionsBotResponse {
  transactions: TransactionBot[];
  page: number;
  hasNextPage: boolean;
  total: number;
}

export type TransactionsSortField = "token" | "type" | "timestamp" | "value";

export interface TransactionSort {
  sortField: TransactionsSortField;
  sortType: "asc" | "desc";
}

export type TransactionFilters = {
  transactionType?: TransactionType;
  ageHoursMin?: string;
  ageHoursMax?: string;
  priceMin?: string;
  priceMax?: string;
  valueMin?: string;
  valueMax?: string;
};

export type TransactionBotFilters = {
  fromTimestamp?: string;
  toTimestamp?: string;
  isBuy?: boolean;
  isSell?: boolean;
  minPrice?: string;
  maxPrice?: string;
  minValue?: string;
  maxValue?: string;
};
